import script from "./LocationSelection.vue?vue&type=script&lang=ts&setup=true"
export * from "./LocationSelection.vue?vue&type=script&lang=ts&setup=true"

import "./LocationSelection.vue?vue&type=style&index=0&id=507299ed&lang=scss"

const __exports__ = script;

export default __exports__